module.exports = __webpack_public_path__ + "img/COACHING_bg.ee1dc45e.svg";